import { render } from "./PackagesCatalog.vue?vue&type=template&id=49d8ed54&scoped=true"
import script from "./PackagesCatalog.vue?vue&type=script&lang=js"
export * from "./PackagesCatalog.vue?vue&type=script&lang=js"

import "./PackagesCatalog.vue?vue&type=style&index=0&id=49d8ed54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d8ed54"]])

export default __exports__